import { Form, FormItem } from 'components/Base/Form';
import { Input, PhoneInput } from 'components/Base/Input';
import { TEditEventFamilyFormProps } from './EditEventFamilyForm.types';
import useGetFormData from './EditEventFamilyForm.data';

const EditEventFamilyForm = ({ form, data }: TEditEventFamilyFormProps) => {
  const { editEventFamilyFormFields } = useGetFormData();
  const { firstName, lastName, email, phone } = editEventFamilyFormFields;

  return (
    <Form
      form={form}
      initialValues={{
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        phone: data.phone,
      }}
    >
      <FormItem {...firstName}>
        <Input placeholder={firstName.placeholder} />
      </FormItem>
      <FormItem {...lastName}>
        <Input placeholder={lastName.placeholder} />
      </FormItem>
      <FormItem {...email}>
        <Input placeholder={email.placeholder} />
      </FormItem>
      <FormItem {...phone}>
        <PhoneInput placeholder={phone.placeholder} />
      </FormItem>
    </Form>
  );
};

export default EditEventFamilyForm;
